// extracted by mini-css-extract-plugin
export var activeDot = "_2k-c";
export var buttonContainer = "_2k-9";
export var channelButton = "_2k-a";
export var clickable = "_2k-d";
export var content = "_2k-0";
export var contentFull = "_2k-2";
export var contentThird = "_2k-1";
export var contentWrapper = "_2k-7";
export var description = "_2k-5";
export var heightShort = "_2k-f";
export var image = "_2k-3";
export var imageContainer = "_2k-4";
export var selectButton = "_2k-e";
export var spinnerContainer = "_2k-b";
export var titleContent = "_2k-8";
export var titleWrapper = "_2k-6";